"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index189.js");var n=e.engineUserAgent,i=/(?:ipad|iphone|ipod).*applewebkit/i.test(n);exports.engineIsIos=i;
